// Centralized bilingual content + assets for Revelo
export const LOGO = {
  light: "https://customer-assets.emergentagent.com/job_youth-care-hk/artifacts/ar19tb7a_revelo_blue_163B71.png",
  dark: "https://customer-assets.emergentagent.com/job_youth-care-hk/artifacts/2t1edg16_Re.png",
};

export const ACTIVITY_PHOTOS = [
  "https://images.pexels.com/photos/7983557/pexels-photo-7983557.jpeg",
  "https://images.pexels.com/photos/15377728/pexels-photo-15377728.jpeg",
  "https://images.pexels.com/photos/7551616/pexels-photo-7551616.jpeg",
];

export const TEAM_AVATARS = [
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1506863530036-1efeddceb993?w=400&h=400&fit=crop&crop=faces",
  "https://images.pexels.com/photos/26872232/pexels-photo-26872232.jpeg?auto=compress&cs=tinysrgb&w=400",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1554151228-14d9def656e4?w=400&h=400&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=400&fit=crop&crop=faces",
];

export const NAV_LINKS = [
  { key: "home", path: "/" },
  { key: "about", path: "/about" },
  { key: "team", path: "/team" },
  { key: "workshops", path: "/workshops" },
  { key: "gallery", path: "/gallery" },
  { key: "partners", path: "/partners" },
  { key: "contact", path: "/contact" },
];

export const t = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      workshops: "Our Work",
      gallery: "Gallery",
      activities: "Activities",
      resources: "Resources",
      partners: "Partners",
      team: "Team",
      contact: "Contact",
      cta: "Host a Workshop",
    },
    hero: {
      eyebrow: "Student-led Volunteer Initiative",
      headline: "Reveal scams\nbefore they harm.",
      sub: "Digital scams are becoming harder to recognise, but no elderly person should face them alone. Revelo brings youth-led education, AI scam awareness, and community care to help older adults stay safe with confidence.",
      cta1: "Partner With Us",
      cta2: "Join as Volunteer",
      cta3: "Explore Our Work",
      shadow_labels: ["Fake calls", "Suspicious links", "AI voice scams", "Money transfer scams"],
      reveal_tagline: "Reveal scams before they harm.",
    },
    about: {
      title: "About Revelo",
      body: "Revelo helps elderly communities stay safer in a world where scams are becoming harder to spot. Led by students, we run in-person workshops with simple explanations, real-life examples and AI scam awareness to help older adults recognize risks before harm occurs.",
      values: [
        { title: "Protection", body: "Helping elderly people stay safe from scams and digital deception." },
        { title: "Education", body: "Teaching practical anti-scam knowledge through workshops, examples, games, and role-play." },
        { title: "Care", body: "Supporting elderly people with patience, empathy, and clarity." },
        { title: "Community", body: "Connecting students, families, NGOs, elderly centres, and sponsors to build a safer digital community." },
      ],
    },
    why: {
      title: "Why Our Work Matters",
      intro: "",
      cards: [
        { title: "Clearer Awareness", body: "Scams can appear through a call, message, link, or familiar voice. We help older adults notice warning signs without fear." },
        { title: "Practice, Not Panic", body: "Through real-life scenarios and role-play, participants learn how to pause, verify, and ask for help before responding." },
        { title: "Support Around Them", body: "We work with NGOs and elderly centres to make digital safety a shared community effort." },
      ],
    },
    what: {
      title: "What We Do",
      intro: "Revelo turns anti-scam education into clear, practical workshops for older adults. Through real-life scenarios, AI scam awareness, and student-led support, we help participants learn what to notice, what to question, and when to ask for help.",
      features: [
        { title: "Practical Scam Education", body: "We break down common scams such as fake calls, suspicious links, WhatsApp messages and impersonation attempts using simple, everyday examples." },
        { title: "AI Scam Awareness", body: "We explain how AI voice scams and deepfake-related deception work in a way that feels clear, calm and easy to understand." },
        { title: "Scenario Practice", body: "Participants practise what to say and do through role-play, short demonstrations and real-life scam situations." },
        { title: "Youth-Elderly Support", body: "Student volunteers guide participants patiently, helping them feel more confident when facing unfamiliar digital risks." },
      ],
    },
    programs: {
      title: "Workshop Programs",
      intro: "Revelo offers flexible workshop formats for elderly centres, NGOs, schools, and community organisations. Our programs can be adapted according to the needs, schedule, and digital confidence level of each elderly community.",
      tiers: [
        {
          tag: "Single session",
          title: "Introductory Workshop",
          duration: "60–120 minutes",
          summary: "Best for first-time collaboration or single-session events.",
          points: ["Common scam types", "Fake phone calls", "Suspicious links", "AI voice scam introduction", "Simple role-play", "Anti-scam checklist"],
        },
        {
          tag: "3 weeks",
          title: "3-Week Core Program",
          duration: "Weekly sessions",
          summary: "Best for elderly centres or NGOs looking for a short structured program.",
          points: ["Week 1: Common Scams and Red Flags", "Week 2: AI Voice Scams and Identity Verification", "Week 3: Role-play and Safe Response Practice"],
        },
        {
          tag: "6 weeks",
          title: "6-Week Extended Program",
          duration: "Weekly sessions",
          summary: "Best for longer community partnerships or pilot programs.",
          points: ["Week 1: Understanding Modern Scams", "Week 2: Phone Scams and Fake Bank Calls", "Week 3: Suspicious Links and Online Messages", "Week 4: AI Voice Scam Awareness", "Week 5: Money Transfer and Personal Data Safety", "Week 6: Role-play, Review, and Family Safety Plan"],
        },
      ],
    },
    ourWork: {
      eyebrow: "Our Work",
      title: "Our Work",
      subtitle: "Revelo designs anti-scam education workshops around the needs of each elderly community, combining practical examples, AI scam awareness, and student-led support.",
      processTitle: "How We Work",
      processIntro: "Every Revelo workshop is shaped around the community we work with. We adapt our content, activities, pace and examples according to the needs of each elderly centre or organization.",
      process: [
        { title: "Understand the Community", body: "We first learn about the organization, participant background, session length and key concerns." },
        { title: "Design the Right Content", body: "We select relevant scam topics, examples and activities based on what the participants need most." },
        { title: "Deliver Interactive Learning", body: "Our student volunteers use simple explanations, real-life scenarios, role-play and AI scam awareness to make learning clear and practical." },
        { title: "Reflect and Improve", body: "After each session, we review what worked well and continue refining our materials for future communities." },
      ],
      formatsTitle: "Flexible Formats",
      formatsIntro: "Our workshops can be delivered as a one-off session, a short programme, or a longer community partnership. The length may vary, but the goal remains the same: helping older adults recognize risks before harm occurs.",
      formats: [
        { title: "One-off Session", body: "Suitable for first-time engagement or introductory anti-scam education." },
        { title: "Short Programme", body: "A structured format over several sessions, allowing more examples and participant practice." },
        { title: "Extended Programme", body: "A longer collaboration with more discussion, repetition, role-play and community follow-up." },
      ],
      focusTitle: "Focus Areas",
      focusTags: ["Scam calls", "Suspicious links", "WhatsApp / SMS scams", "AI voice scams", "Money transfer scams", "Personal data protection", "Identity verification", "Family safety code"],
      galleryTitle: "In Action",
      gallerySubtitle: "A glimpse into Revelo's workshops, learning moments, and community-based anti-scam education.",
      galleryCta: "View Full Gallery",
      galleryCaptions: [
        "In-person anti-scam workshops",
        "Student volunteers supporting elderly participants",
        "Scenario practice and discussion",
        "Community-based digital safety learning",
        "Workshop materials and learning moments",
        "Preparation and team coordination",
      ],
    },
    activities: {
      title: "In the Community",
      intro: "Revelo brings anti-scam education directly into elderly communities through face-to-face workshops, interactive activities, and community partnerships. Our activities help us understand how elderly participants learn, remember, and apply scam-prevention knowledge in real life.",
      items: [
        { date: "17 April", title: "Senior Anti-Scam Workshop", partner: "The Salvation Army / HK SAGE", format: "Face-to-face workshop", focus: "Scam awareness, suspicious calls, personal data protection, and safe responses." },
        { date: "22 April", title: "Senior Anti-Scam Workshop", partner: "The Salvation Army / HK SAGE", format: "Face-to-face workshop", focus: "Suspicious messages, unknown links, and real-life scam scenarios." },
        { date: "29 April", title: "Senior Anti-Scam Workshop", partner: "The Salvation Army / HK SAGE", format: "Face-to-face workshop", focus: "AI voice scam awareness, identity verification, and role-play practice." },
      ],
      note: "More activities and photos will be added as our community programs continue.",
    },
    resources: {
      title: "Resources",
      intro: "Revelo creates simple and practical anti-scam resources for elderly people, families, and community organisations. These resources are designed to help people pause, verify, and ask for help before responding to suspicious situations.",
      items: [
        { title: "Scam Call Checklist", body: "A simple checklist for elderly people to use when receiving suspicious phone calls." },
        { title: "Suspicious Link Guide", body: "A practical guide for handling suspicious SMS, WhatsApp messages, and unknown links." },
        { title: "AI Voice Scam Guide", body: "A guide explaining how AI voice scams work and how elderly people can verify identity safely." },
        { title: "Family Safety Code", body: "A simple family-based method to reduce the risk of impersonation scams." },
      ],
    },
    partners: {
      title: "Our Partners",
      intro: "Revelo is grateful to collaborate with community organisations that share our commitment to elderly protection, digital safety, and accessible anti-scam education.",
      list: ["The Salvation Army", "HK SAGE / Hong Kong Society for the Aged"],
      ctaCopy: "We welcome partnerships with elderly centres, NGOs, schools, community organisations, and sponsors who share our mission of making anti-scam education accessible, practical, and human-centred.",
      ctaButton: "Partner With Us",
    },
    team: {
      title: "Our Team",
      intro: "Revelo is led by a team of student volunteers committed to elderly protection, digital safety education, and community care. Our team works across outreach, design, human resources, and event planning to transform our mission into real community action.",
      leadershipTitle: "Founding Team",
      executiveTitle: "Executive Team 2025–2026",
      directorsTitle: "Leadership Team 2025–2026",
      leadership: [
        { name: "Melody Jiang", role: "President" },
        { name: "Sita Ho", role: "Vice President" },
        { name: "Bailey Chau", role: "Vice President" },
        { name: "Shirley Ding", role: "Vice President" },
      ],
      departments: [
        { name: "Marketing", description: "The Marketing team leads outreach, public communication, social media, website content, and community storytelling.", members: ["Colin Shum", "Alvis Leung"] },
        { name: "Design", description: "The Design team creates Revelo's visual identity, workshop materials, posters and social media graphics.", members: ["Kayli Lok", "Grace Chui"] },
        { name: "Human Resources", description: "The Human Resources team manages volunteer recruitment, onboarding, team communication, and internal coordination.", members: ["Megan Lo", "Jayden Chan"] },
        { name: "Events", description: "The Events team plans workshops, coordinates logistics, prepares activities, and supports on-site delivery.", members: ["Tristyn Kwan", "Venus Lai"] },
      ],
    },
    getInvolved: {
      title: "Get Involved",
      intro: "Whether you are an elderly centre, NGO, student volunteer, sponsor, or community partner, there are many ways to support Revelo's mission.",
      cards: [
        { title: "Host a Workshop", body: "Invite Revelo to host an anti-scam workshop for your elderly community.", button: "Host a Workshop", interest: "Partnership / sponsorship" },
        { title: "Join as Volunteer", body: "Join our youth volunteer team and help elderly participants learn with patience, care, and creativity.", button: "Join as Volunteer", interest: "Joining as a volunteer" },
        { title: "Support Our Work", body: "Support our workshop materials, printed resources, volunteer training, and community outreach.", button: "Support Revelo", interest: "Sponsorship / partnership" },
      ],
    },
    contact: {
      title: "Contact Revelo",
      intro: "Interested in hosting a workshop, joining our volunteer team, or supporting Revelo's work? We would love to hear from you.",
      fields: {
        name: "Name",
        organisation: "Organisation / School",
        email: "Email",
        phone: "Phone / WhatsApp",
        interestLabel: "I am interested in",
        message: "Message",
        submit: "Send Message",
        submitting: "Sending...",
        success: "Thank you. Your message has been sent — we'll be in touch soon.",
        error: "Something went wrong. Please try again.",
      },
      interests: ["Partnership / sponsorship", "Media / general enquiry"],
      email: "revelo.hk@gmail.com",
      whatsapp: "54210539",
      instagram: "@revelo.hk",
    },
    volunteer: {
      eyebrow: "Volunteer Recruitment",
      title: "Want to join Revelo as a volunteer?",
      body: "We're always looking for passionate students to join our team. Apply through our volunteer recruitment form below.",
      cta: "Apply via Google Form",
      formUrl: "https://forms.gle/3dG3herAFaC768ZM9",
    },
    footer: {
      description: "Revelo is a youth-led anti-scam education initiative helping elderly communities stay safe in the age of AI-driven deception.",
      copyright: "© 2025–2026 Revelo. All rights reserved.",
      navTitle: "Explore",
      contactTitle: "Contact",
      followTitle: "Follow",
    },
  },
  zh: {
    nav: {
      home: "首頁",
      about: "關於我們",
      workshops: "我們的工作",
      gallery: "活動相簿",
      activities: "活動",
      resources: "資源",
      partners: "合作夥伴",
      team: "團隊",
      contact: "聯絡",
      cta: "舉辦工作坊",
    },
    hero: {
      eyebrow: "學生義工主導項目",
      headline: "未受其害，\n先識其詐。",
      sub: "數碼詐騙手法不斷演變，長者不應獨自面對風險。Revelo 透過學生主導的防騙教育、AI 詐騙意識提升及社區支援，協助長者建立辨識風險的能力與信心，安心面對不斷變化的數碼環境。",
      cta1: "與我們合作",
      cta2: "加入義工團隊",
      cta3: "了解我們的工作",
      shadow_labels: ["假電話", "陌生連結", "AI 假聲音", "轉帳騙局"],
      reveal_tagline: "在傷害發生前，看清詐騙。",
    },
    about: {
      title: "關於 Revelo",
      body: "面對不斷演變的數碼詐騙，長者需要的不只是提醒，更是清晰、耐心而可實踐的支援。Revelo 由學生團隊主導，透過面對面工作坊、真實情境案例和 AI 詐騙意識教育，陪伴長者建立辨識風險的能力，在受害前作出更安心的判斷。",
      values: [
        { title: "保護", body: "保護長者免受詐騙和數碼欺詐的傷害。" },
        { title: "教育", body: "透過工作坊、真實案例、互動遊戲和角色扮演，教授實用防騙知識。" },
        { title: "關懷", body: "以耐心、同理心和清晰講解，陪伴長者學習數碼安全。" },
        { title: "社區", body: "連結學生、家庭、NGO、長者中心和支持者，共同建立更安全的數碼社區。" },
      ],
    },
    why: {
      title: "我們的工作為何重要",
      intro: "",
      cards: [
        { title: "更清晰的意識", body: "詐騙可能透過電話、訊息、連結或熟悉的聲音出現。我們幫助長者在不感到恐懼的情況下，留意當中的警號。" },
        { title: "練習，而非恐慌", body: "透過真實情境和角色扮演，參加者學習在回應前先停一停、核實資訊，並尋求協助。" },
        { title: "身邊的支援", body: "我們與 NGO 和長者中心合作，讓數碼安全成為整個社區共同努力的目標。" },
      ],
    },
    what: {
      title: "我們做甚麼",
      intro: "Revelo 將防騙教育轉化為清晰、實用、長者容易理解的工作坊。透過真實情境、AI 詐騙意識教育和學生義工支援，我們幫助參加者學會辨識風險、提出疑問，並在需要時尋求協助。",
      features: [
        { title: "實用防騙教育", body: "我們以日常例子講解假電話、陌生連結、WhatsApp 訊息和假冒身份等常見詐騙手法。" },
        { title: "AI 詐騙意識", body: "我們用清晰、冷靜和容易理解的方式，介紹 AI 假聲音和 deepfake 相關欺詐。" },
        { title: "情境練習", body: "參加者透過角色扮演、短劇示範和真實案例，練習遇到可疑情況時如何回應。" },
        { title: "學生義工支援", body: "學生義工以耐心陪伴長者學習，協助他們在面對陌生數碼風險時更有信心。" },
      ],
    },
    programs: {
      title: "工作坊課程",
      intro: "Revelo 為長者中心、NGO、學校和社區機構提供彈性的工作坊形式。我們的課程可以根據每個長者社群的需要、時間安排和數碼信心水平作出調整。",
      tiers: [
        {
          tag: "單次活動",
          title: "入門防騙工作坊",
          duration: "60–120 分鐘",
          summary: "適合首次合作或單次活動。",
          points: ["常見詐騙類型", "假電話", "陌生連結", "AI 假聲音詐騙介紹", "簡單角色扮演", "防騙清單"],
        },
        {
          tag: "三週",
          title: "三週核心課程",
          duration: "每週一次",
          summary: "適合希望進行短期結構化課程的長者中心或 NGO。",
          points: ["第 1 週：常見詐騙和警號", "第 2 週：AI 假聲音詐騙與身份核實", "第 3 週：角色扮演和安全應對練習"],
        },
        {
          tag: "六週",
          title: "六週延伸課程",
          duration: "每週一次",
          summary: "適合較長期的社區合作或試行計劃。",
          points: ["第 1 週：認識現代詐騙", "第 2 週：電話詐騙和假銀行來電", "第 3 週：陌生連結和網上訊息", "第 4 週：AI 假聲音詐騙意識", "第 5 週：轉帳風險和個人資料安全", "第 6 週：角色扮演、複習和家庭安全計劃"],
        },
      ],
    },
    ourWork: {
      eyebrow: "我們的工作",
      title: "我們的工作",
      subtitle: "Revelo 因應不同長者社群的需要設計防騙教育工作坊，結合實用例子、AI 詐騙意識和學生義工支援。",
      processTitle: "我們的合作方式",
      processIntro: "每場 Revelo 工作坊都圍繞合作社群的特點設計。我們根據每間長者中心或機構的需要，靈活調整內容、活動、節奏和例子。",
      process: [
        { title: "了解社群", body: "我們先了解合作機構、參加者背景、課堂時長和最關注的議題。" },
        { title: "設計合適內容", body: "我們根據參加者最需要的內容，選擇相關詐騙主題、例子和活動。" },
        { title: "互動式教學", body: "學生義工以簡單講解、真實情境、角色扮演和 AI 詐騙意識教育，讓學習清晰實用。" },
        { title: "反思與改進", body: "每次工作坊後，我們會檢視成效，持續優化教材，為下一個社群做得更好。" },
      ],
      formatsTitle: "彈性形式",
      formatsIntro: "我們的工作坊可以一次性舉行、安排為短期課程，或發展成長期社區合作。形式可以調整，但目標一致：幫助長者在受害前辨識風險。",
      formats: [
        { title: "單次工作坊", body: "適合首次合作或入門防騙教育。" },
        { title: "短期課程", body: "由數節課程組成，提供更多例子和參與練習。" },
        { title: "長期合作", body: "較長期的合作，包含更多討論、重複練習、角色扮演和社區跟進。" },
      ],
      focusTitle: "關注議題",
      focusTags: ["詐騙電話", "陌生連結", "WhatsApp / SMS 詐騙", "AI 假聲音詐騙", "轉帳詐騙", "個人資料保護", "身份核實", "家庭安全密語"],
      galleryTitle: "活動現場",
      gallerySubtitle: "Revelo 工作坊、學習片段和社區防詐騙教育的小掠影。",
      galleryCta: "查看完整相簿",
      galleryCaptions: [
        "面對面防詐騙工作坊",
        "學生義工陪伴長者學習",
        "情境練習與討論",
        "社區為本的數碼安全學習",
        "工作坊教材與學習片段",
        "活動準備與團隊協調",
      ],
    },
    activities: {
      title: "走進社區",
      intro: "Revelo 透過面對面工作坊、互動活動和社區合作，將防詐騙教育帶入長者社群。我們的活動幫助我們了解長者如何在現實生活中學習、記住並應用防騙知識。",
      items: [
        { date: "4 月 17 日", title: "長者防詐騙工作坊", partner: "救世軍 / 香港耆康老人福利會", format: "面對面工作坊", focus: "詐騙意識、可疑來電、個人資料保護和安全應對。" },
        { date: "4 月 22 日", title: "長者防詐騙工作坊", partner: "救世軍 / 香港耆康老人福利會", format: "面對面工作坊", focus: "可疑訊息、陌生連結和真實詐騙情境。" },
        { date: "4 月 29 日", title: "長者防詐騙工作坊", partner: "救世軍 / 香港耆康老人福利會", format: "面對面工作坊", focus: "AI 假聲音詐騙意識、身份核實和角色扮演練習。" },
      ],
      note: "隨著社區項目持續進行，我們將加入更多活動和照片。",
    },
    resources: {
      title: "防騙資源",
      intro: "Revelo 為長者、家庭和社區機構製作簡單實用的防騙資源。這些資源旨在幫助大家在面對可疑情況時，先停一停、核實資訊，並尋求協助。",
      items: [
        { title: "可疑電話清單", body: "一份簡單清單，幫助長者在收到可疑電話時作出安全判斷。" },
        { title: "陌生連結指南", body: "一份實用指南，教導如何處理可疑 SMS、WhatsApp 訊息和陌生連結。" },
        { title: "AI 假聲音詐騙指南", body: "一份介紹 AI 假聲音詐騙及安全核實身份方法的指南。" },
        { title: "家庭安全密語", body: "一個以家庭為本的簡單方法，幫助減低假冒親人詐騙的風險。" },
      ],
    },
    partners: {
      title: "合作夥伴",
      intro: "Revelo 很感謝能與同樣關注長者保障、數碼安全和普及防騙教育的社區機構合作。",
      list: ["救世軍", "香港耆康老人福利會"],
      ctaCopy: "我們歡迎長者中心、NGO、學校、社區機構和贊助者與我們合作，一同推動更易接觸、更實用、更以人為本的防詐騙教育。",
      ctaButton: "與我們合作",
    },
    team: {
      title: "我們的團隊",
      intro: "Revelo 由一群關心長者保障、數碼安全教育和社區關懷的學生義工帶領。我們的團隊分別負責宣傳、設計、人力資源和活動策劃，將理念轉化為實際社區行動。",
      leadershipTitle: "創辦團隊",
      executiveTitle: "2025–2026 執行團隊",
      directorsTitle: "2025–2026 領導團隊",
      leadership: [
        { name: "Melody Jiang", role: "會長" },
        { name: "Sita Ho", role: "副會長" },
        { name: "Bailey Chau", role: "副會長" },
        { name: "Shirley Ding", role: "副會長" },
      ],
      departments: [
        { name: "Marketing 宣傳", description: "Marketing 團隊負責對外宣傳、公共溝通、社交媒體、網站內容和社區故事呈現。", members: ["Colin Shum", "Alvis Leung"] },
        { name: "Design 設計", description: "Design 團隊負責 Revelo 的視覺形象、工作坊材料、海報和社交媒體圖像。", members: ["Kayli Lok", "Grace Chui"] },
        { name: "Human Resources 人力資源", description: "Human Resources 團隊負責義工招募、入職安排、團隊溝通和內部協調。", members: ["Megan Lo", "Jayden Chan"] },
        { name: "Events 活動", description: "Events 團隊負責策劃工作坊、協調後勤、準備活動內容和支援現場執行。", members: ["Tristyn Kwan", "Venus Lai"] },
      ],
    },
    getInvolved: {
      title: "參與我們",
      intro: "無論你是長者中心、NGO、學生義工、贊助者或社區夥伴，都可以用不同方式支持 Revelo 的使命。",
      cards: [
        { title: "舉辦工作坊", body: "邀請 Revelo 為你的長者社群舉辦防詐騙工作坊。", button: "舉辦工作坊", interest: "合作 / 贊助" },
        { title: "加入義工團隊", body: "加入我們的學生義工團隊，以耐心、關懷和創意陪伴長者學習。", button: "加入義工", interest: "加入義工團隊" },
        { title: "支持我們的工作", body: "支持我們的工作坊材料、印刷資源、義工培訓和社區推廣。", button: "支持 Revelo", interest: "贊助 / 合作" },
      ],
    },
    contact: {
      title: "聯絡 Revelo",
      intro: "有興趣舉辦工作坊、加入義工團隊或支持 Revelo 的工作？歡迎與我們聯絡。",
      fields: {
        name: "姓名",
        organisation: "機構 / 學校",
        email: "電郵",
        phone: "電話 / WhatsApp",
        interestLabel: "我有興趣",
        message: "訊息",
        submit: "發送訊息",
        submitting: "傳送中...",
        success: "感謝你的訊息！我們會盡快與你聯絡。",
        error: "傳送失敗，請稍後再試。",
      },
      interests: ["合作 / 贊助", "媒體 / 一般查詢"],
      email: "revelo.hk@gmail.com",
      whatsapp: "54210539",
      instagram: "@revelo.hk",
    },
    volunteer: {
      eyebrow: "義工招募",
      title: "想加入 Revelo 義工團隊？",
      body: "我們正積極招募有熱誠的學生義工。請透過下方的招募表格報名加入我們。",
      cta: "前往義工招募表格",
      formUrl: "https://forms.gle/3dG3herAFaC768ZM9",
    },
    footer: {
      description: "Revelo 是一個由學生主導的防詐騙教育項目，幫助長者社群在 AI 驅動的數碼欺詐時代保持安全。",
      copyright: "© 2025–2026 Revelo. 版權所有。",
      navTitle: "瀏覽",
      contactTitle: "聯絡",
      followTitle: "追蹤",
    },
  },
};
